{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/meter';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/MeterAnatomy2.svg';

export const section = 'Hooks';
export const description = 'Provides the accessibility implementation for a meter component.';
export const isSubpage = true;

# useMeter

<PageDescription>{docs.exports.useMeter.description}</PageDescription>

```tsx render files={["starters/hooks/src/Meter.tsx", "starters/hooks/src/Meter.css", "starters/hooks/src/Form.css"]}
"use client";
import {Meter} from 'hooks-starter/Meter';

<Meter label="Storage space" value={25} />
```

## API

<Anatomy />

```tsx
<Meter>
  <Label />
</Meter>
```

<FunctionAPI function={docs.exports.useMeter} links={docs.links} />

### AriaMeterProps

<InterfaceType {...docs.exports.AriaMeterProps} />

### MeterAria

<InterfaceType {...docs.exports.MeterAria} />
